(() => {
  // Delegation also covers React forms mounted after the page has loaded.
  document.addEventListener("click", (event) => {
    const button = event.target.closest?.("[data-consent-toggle]");
    if (!button || button.disabled) return;
    const group = button.closest("[data-consent-disclosure]");
    const content = group?.querySelector("[data-consent-content]");
    if (!content) return;

    event.preventDefault();
    const expanded = button.getAttribute("aria-expanded") !== "true";
    group.toggleAttribute("data-expanded", expanded);
    button.setAttribute("aria-expanded", String(expanded));
    button.textContent = expanded ? "Show less" : "Read full consent";

    // Clipped policy links must not become invisible keyboard focus targets.
    content.querySelectorAll("a").forEach((link) => {
      if (expanded) link.removeAttribute("tabindex");
      else link.setAttribute("tabindex", "-1");
    });
  });
})();
